export const VIDEO_TRENDING_UPDATE = "video_trending_update";
export const VIDEO_TRENDING_ERROR = "video_trending_error";
export const VIDEO_TRENDING_NULL = "video_trending_null";
